import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppStore } from "@/hooks/useAppStore";

/**
 * App route handler for handling protected admin routes.
 * 
 * Will redirect to admin login page if session is not found.
 */
export const AdminRoute = () => {
    const user = useAppStore((state) => state.adminUser);
    //
    const location = useLocation();
    if (!user) {
        return <Navigate to={`/admin-login?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    }
    return <Outlet />;

};

export default AdminRoute;
